export const CUSTOMER_ATTEMPT = "CUSTOMER_ATTEMPT";
export const CUSTOMER_SUCCESS = "CUSTOMER_SUCCESS";
export const CUSTOMER_FAILED = "CUSTOMER_FAILED";
export const LOGOUT = "LOGOUT";